import { render, staticRenderFns } from "./addTaskSectionModal.vue?vue&type=template&id=18f04aad&scoped=true"
import script from "./addTaskSectionModal.vue?vue&type=script&lang=js"
export * from "./addTaskSectionModal.vue?vue&type=script&lang=js"
import style0 from "./addTaskSectionModal.vue?vue&type=style&index=0&id=18f04aad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f04aad",
  null
  
)

export default component.exports